import type React from 'react';
import type { ScrollViewProps } from 'react-native';

interface IProps extends ScrollViewProps {}

export type Props = React.FC<IProps>;
